<!-- Hero Section with Roof -->
<section class="hero-section position-relative">
	<div class="container">
		<!-- Title -->
		<div class="row justify-content-center">
			<div class="col-lg-8 col-md-10 text-center ">
				<div class="hero-content">
					<h1 class="display-4 fw-bold text-dark">
						<span class="fw-bold text-primary">M</span>ujer,
						<span class="fw-bold text-primary">E</span>ducación,
						<span class="fw-bold text-primary">Sa</span>lud y
						<span class="fw-bold text-primary">De</span>sarrollo
					</h1>
				</div>
			</div>
		</div>

		<!-- Roof with Logo -->
		<div class="roof-container position-relative text-center ">
			<img src="assets/images/roof.png" alt="Techo de casa" class="img-fluid roof-image">
			<div class="logo-container position-absolute top-50 start-50 translate-middle">
				<img src="assets/images/logoCentral.png" alt="Logo" class="logo-image">
			</div>
		</div>
	</div>
</section>

<!-- Pillars Section -->
<section class="pillars-section pb-5">
	<div class="container">
		<div class="row">
			<div class="col-12">
				<!-- Navigation Tabs as Pillars -->
				<ul class="nav nav-pills mb-4 justify-content-center" id="pillarTabs" role="tablist">
					<li class="nav-item pillar-item" role="presentation">
						<button class="nav-link pillar-button active" id="plan-tab" data-bs-toggle="pill"
							data-bs-target="#plan" type="button" role="tab">
							SALUD SEXUAL<br>Y REPRODUCTIVA
						</button>
					</li>
					<li class="nav-item pillar-item" role="presentation">
						<button class="nav-link pillar-button" id="general-tab" data-bs-toggle="pill"
							data-bs-target="#general" type="button" role="tab">
							PREVENCIÓN DE ACOSO
						</button>
					</li>
					<li class="nav-item pillar-item" role="presentation">
						<button class="nav-link pillar-button" id="therapy-tab" data-bs-toggle="pill"
							data-bs-target="#therapy" type="button" role="tab" aria-selected="true">
							ESTIMULACIÓN TEMPRANA<br>TERAPIA DE LENGUAJE
						</button>
					</li>
				</ul>

				<!-- Tab Content -->
				<div class="tab-content" id="projectTabsContent">

					<!-- Tab 1 Content -->
					<div class="tab-pane fade show active" id="plan" role="tabpanel" aria-labelledby="plan-tab">
						<div class="row g-4 align-items-stretch">
							<div class=" col-lg-6 d-flex align-items-center justify-content-center">
								<img src="assets/images/4.png" class="img-fluid rounded shadow w-80 h-auto "
									alt="Mujer Cuerpo y Salud">
							</div>
							<div class="col-lg-6 d-flex">
								<div class="p-4 bg-white rounded shadow-sm w-80">
									<h3 class="mb-3">Mujer Cuerpo y Salud</h3>
									<p class="mb-4 text-justify">En la actualidad, la comunidad de mujeres sordas debe
										enfrentar la falta de varios recursos relacionados con su desarrollo personal y
										profesional: (i) la falta de bilingüismo (lenguaje de señas y lenguaje escrito),
										(ii) la falta de conocimiento apropiado sobre el lenguaje local; y (iii) la
										escasez de planes educativos sobre salud sexual y reproductiva (SSR). Esta
										situación provoca varios problemas, como la transmisión de enfermedades de
										transmisión sexual, el embarazo no deseado en la adolescencia, la violencia
										sexual y las complicaciones durante el embarazo. Por estas razones, se presenta
										un ecosistema inteligente y una metodología educativa dirigida a mejorar el
										acceso a los programas de SSR en el lenguaje de señas ecuatoriano (ESL),
										empleando técnicas basadas en información interactiva y entornos dinámicos de
										aprendizaje.</p>
									<ul class="mb-4 list-unstyled">
										<li class="mb-2"><i
												class="bi bi-check-circle-fill text-primary me-2"></i>Discapacidad
											Auditiva</li>
										<li class="mb-2"><i
												class="bi bi-check-circle-fill text-primary me-2"></i>Sistemas Expertos
											/ IA</li>
										<li class="mb-2"><i
												class="bi bi-check-circle-fill text-primary me-2"></i>E-Learning</li>
										<li><i class="bi bi-check-circle-fill text-primary me-2"></i>Lengua de señas
											Ecuatoriana</li>
									</ul>
									<div class="text-center">
										<a href="/pillar_1" class="btn btn-primary px-4">Ver Proyecto</a>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- Tab 2 Content -->
					<div class="tab-pane fade" id="general" role="tabpanel" aria-labelledby="general-tab">
						<div class="row g-4 align-items-stretch">
							<div class=" col-lg-6 d-flex align-items-center justify-content-center">
								<img src="assets/images/ARISE.jpeg" class="img-fluid rounded shadow w-80 h-auto "
									alt="Proyecto ARISE">
							</div>
							<div class="col-lg-6 d-flex">
								<div class="p-4 bg-white rounded shadow-sm w-80">
									<h3 class="mb-3">ARISE</h3>
									<p class="mb-4 text-justify">En la actualidad, a pesar del trabajo que se viene
										desarrollando conforme al respeto de los derechos sexuales de niñas, niños y
										adolescentes, todavía existen cifras que demuestran lo contrario, tal como lo
										indica la Unicef que “más de un millón de niñas y adolescentes son víctimas de
										violencia sexualen latinoamérica” (Infobae, 2017).
										La idea es brindar de una herramienta tecnológica educativa para que los
										estudiantes puedan conocer el respeto desde y hacia sus partes íntimas. Las
										cifras con respecto al acoso y abuso sexual en Ecuador indican que “1 de cada 10
										mujeres de 15 años o más fue abusada sexualmente durante su infancia o
										adolescencia, el 9% fue besada o su cuerpo fue tocado en contra de su voluntad,
										el 7% reporta que sus 'partes íntimas' fueron tocadas sin su consentimiento,
										mientras que el 4% asegura que fueron obligadas a desvestirse y mostrar las
										'partes íntimas'” (CNII, 2018).
									</p>
									<ul class="mb-4 list-unstyled">
										<li class="mb-2"><i
												class="bi bi-check-circle-fill text-primary me-2"></i>Prevención de
											acoso</li>
										<li class="mb-2"><i
												class="bi bi-check-circle-fill text-primary me-2"></i>Inteligencia
											artificial</li>
										<li><i class="bi bi-check-circle-fill text-primary me-2"></i>Asistentes
											roboticos</li>
									</ul>
									<div class="text-center">
										<a href="/pillar_2" class="btn btn-primary px-4">Ver Proyecto</a>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!-- Tab 3 Content -->
					<div class="tab-pane fade" id="therapy" role="tabpanel" aria-labelledby="therapy-tab">
						<!-- Project 1 -->
						<div class="row g-4 align-items-stretch">
							<div class=" col-lg-6 d-flex align-items-center justify-content-center">
								<img src="assets/images/Logo-FELPUDO.jpeg" class="img-fluid rounded shadow w-80 h-auto "
									alt="Proyecto FELPUDO">
							</div>
							<div class="col-lg-6 d-flex">
								<div class="p-4 bg-white rounded shadow-sm w-80">
									<h3 class="mb-3">FELPUDO</h3>
									<p class="mb-4">La educación actual contempla la inclusión de Tecnologías de
										Información y Comunicación (TICs), sin embargo existen vacíos con respecto a la
										implementación de herramientas que sirvan de apoyo para la estimulación
										temprana, en la etapa de educación inicial. Es de vital importancia tener en
										cuenta que a nivel mundial el 39% de niños menores de cinco años viven en la
										pobreza y no tienen acceso a la educación inicial, así como el interés que se
										debe dar a los primeros cinco años de vida del niño como “los más importantes
										para el desarrollo del cerebro, incluyendo la adquisición de habilidades
										cognitivas, sociales y emocionales” (World Bank Group, 2015)
									</p>
									<ul class="mb-4 list-unstyled">
										<li class="mb-2"><i
												class="bi bi-check-circle-fill text-primary me-2"></i>Inteligencia
											artificial</li>
										<li class="mb-2"><i
												class="bi bi-check-circle-fill text-primary me-2"></i>Asistentes
											roboticos</li>
										<li><i class="bi bi-check-circle-fill text-primary me-2"></i>Estimulación
											temprana</li>
									</ul>
									<div class="text-center">
										<a href="/pillar_3/felpudo" class="btn btn-primary px-4">Ver Proyecto</a>
									</div>
								</div>
							</div>
						</div>

						<!-- Project 2 -->


						<div class="row g-4 align-items-stretch pt-3">
							<div class=" col-lg-6 d-flex align-items-center justify-content-center">
								<img src="assets/images/Logo-FONA.jpeg" class="img-fluid rounded shadow w-80 h-auto "
									alt="Proyecto FONA">
							</div>
							<div class="col-lg-6 d-flex">
								<div class="p-4 bg-white rounded shadow-sm w-80">
									<h3 class="mb-3">FONA</h3>
									<p class="mb-4">Una de las partes fundamentales del desarrollo en la educación de
										una persona es el habla, ya que la misma permite expresar diferentes
										sentimientos y más aún una manera de manejar de mejor forma cierta información
										con la finalidad de adquirir un conocimiento. Con lo antes mencionado según la
										UNICEF un número importante de niños con trastornos de la comunicación no tienen
										acceso a servicios adecuados de educación especial o atención médica. Del mismo
										modo, en la actualidad existe la deficiencia de servicios importantes como el
										uso de la tecnología para los niños con discapacidades en áreas como la terapia
										del habla y del lenguaje, la fisioterapia y la enseñanza del lenguaje de señas
										(Ochoa-Guaraca, M., Carpio-Moreta, M., Serpa-Andrade, L., Robles-Bykbaev, V.,
										Lopez-Nores, M., & Duque, n.d.)</p>
									<ul class="mb-4 list-unstyled">
										<li class="mb-2"><i
												class="bi bi-check-circle-fill text-primary me-2"></i>Inteligencia
											artificial</li>
										<li class="mb-2"><i
												class="bi bi-check-circle-fill text-primary me-2"></i>Asistentes
											roboticos</li>
										<li><i class="bi bi-check-circle-fill text-primary me-2"></i>Estimulación
											temprana</li>
									</ul>
									<div class="text-center">
										<a href="/pillar_3/fona" class="btn btn-primary px-4">Ver Proyecto</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>


<section id="services-section" class="py-5">
	<div class="container">
		<div class="row g-4">
			<!-- Servicio 1 -->
			<div class="col-md-4">
				<div class="card h-100 border-0 shadow-sm text-center p-4">
					<div class="icon-wrapper mb-4">
						<i class="bi bi-people-fill text-primary fs-1"></i>
					</div>
					<div class="card-body">
						<h3 class="card-title h5">Nuestra comunidad</h3>
						<p class="card-text">Se parte de la familia y aporta en el desarrollo de planes estratégicos
							para mejorar y empoderar de su derecho a la educación de niñas y jóvenes con y sin
							discapacidad.</p>
					</div>
				</div>
			</div>

			<!-- Servicio 2 -->
			<div class="col-md-4">
				<div class="card h-100 border-0 shadow-sm text-center p-4">
					<div class="icon-wrapper mb-4">
						<i class="bi bi-send-fill text-primary fs-1"></i>
					</div>
					<div class="card-body">
						<h3 class="card-title h5">Recursos</h3>
						<p class="card-text">Brindamos materiales de soporte orientado a instructores y personas de
							interés en educación inicial, terapia de lenguaje, prevención de acoso y derechos sexuales y
							reproductivos.</p>
					</div>
				</div>
			</div>

			<!-- Servicio 3 -->
			<div class="col-md-4">
				<div class="card h-100 border-0 shadow-sm text-center p-4">
					<div class="icon-wrapper mb-4">
						<i class="bi bi-file-earmark-text-fill text-primary fs-1"></i>
					</div>
					<div class="card-body">
						<h3 class="card-title h5">Investigación</h3>
						<p class="card-text">Encuentra artículos científicos, estadísticas actualizadas y variedad de
							información relacionada con estrategias para empoderar el derecho a la educación en mujeres
							con y sin discapacidad.</p>
					</div>
				</div>
			</div>

			<!-- Servicio 4 -->
			<div class="col-md-4">
				<div class="card h-100 border-0 shadow-sm text-center p-4">
					<div class="icon-wrapper mb-4">
						<i class="bi bi-robot text-primary fs-1"></i>
					</div>
					<div class="card-body">
						<h3 class="card-title h5">Y mucho más</h3>
						<p class="card-text">Comprometidos con nuestro objetivo de crear soluciones para grupos
							socialmente excluidos, fusionamos la tecnología con estrategias de inclusión.</p>
					</div>
				</div>
			</div>

			<!-- Servicio 5 -->
			<div class="col-md-4">
				<div class="card h-100 border-0 shadow-sm text-center p-4">
					<div class="icon-wrapper mb-4">
						<i class="bi bi-cup-hot-fill text-primary fs-1"></i>
					</div>
					<div class="card-body">
						<h3 class="card-title h5">Platícalo</h3>
						<p class="card-text">Compártelo con los demás, hagamos que nuestro objetivo por crear un mejor
							acceso a la educación en mujeres con y sin discapacidad crezca.</p>
					</div>
				</div>
			</div>

			<!-- Servicio 6 -->
			<div class="col-md-4">
				<div class="card h-100 border-0 shadow-sm text-center p-4">
					<div class="icon-wrapper mb-4">
						<i class="bi bi-info-circle-fill text-primary fs-1"></i>
					</div>
					<div class="card-body">
						<h3 class="card-title h5">Contacto</h3>
						<p class="card-text">Sus sugerencias y aportes son muy valiosos para nosotros, póngase en
							contacto con nosotros.</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>


<section id="initiatives" class="py-5 bg-light">
	<div class="container">
		<div class="row justify-content-center mb-5">
			<div class="col-lg-8 text-center">
				<h2 class="display-5 fw-bold">Una iniciativa de:</h2>
			</div>
		</div>

		<div class="row justify-content-center">
			<div class="col-lg-10">
				<div id="initiativesCarousel" class="carousel slide" data-bs-ride="carousel">
					<!-- Indicadores -->
					<div class="carousel-indicators">
						<button type="button" data-bs-target="#initiativesCarousel" data-bs-slide-to="0" class="active"
							aria-current="true" aria-label="Slide 1"></button>
						<button type="button" data-bs-target="#initiativesCarousel" data-bs-slide-to="1"
							aria-label="Slide 2"></button>
						<button type="button" data-bs-target="#initiativesCarousel" data-bs-slide-to="2"
							aria-label="Slide 3"></button>
					</div>

					<!-- Slides -->
					<div class="carousel-inner">
						<!-- Item 1 -->
						<div class="carousel-item active">
							<div class="card border-0 bg-transparent">
								<div class="card-body">
									<img src="assets/images/ups.jpg" class="img-fluid"
										alt="Universidad Politécnica Salesiana">
									<blockquote class="blockquote mt-3">
										<p class="fs-5">Universidad Politécnica Salesiana (Ecuador)</p>
									</blockquote>
								</div>
							</div>
						</div>

						<!-- Item 2 -->
						<div class="carousel-item">
							<div class="card border-0 bg-transparent">
								<div class="card-body">
									<img src="assets/images/logoGIIATa.png" class="img-fluid"
										alt="Grupo de Investigación GIIATA">
									<blockquote class="blockquote mt-3">
										<p class="fs-5">Grupo de Investigación en Inteligencia Artificial y Tecnologías
											de Asistencia</p>
									</blockquote>
								</div>
							</div>
						</div>

						<!-- Item 3 -->
						<div class="carousel-item">
							<div class="card border-0 bg-transparent">
								<div class="card-body">
									<img src="assets/images/LogoCatedraUNESCO.png" class="img-fluid"
										alt="Cátedra Unesco">
									<blockquote class="blockquote mt-3">
										<p class="fs-5">Cátedra Unesco "Tecnologías de Apoyo a la Inclusión Educativa"
											(Ecuador)</p>
									</blockquote>
								</div>
							</div>
						</div>
					</div>

					<!-- Controles -->
					<button class="carousel-control-prev" type="button" data-bs-target="#initiativesCarousel"
						data-bs-slide="prev">
						<span class="carousel-control-prev-icon" aria-hidden="true"></span>
						<span class="visually-hidden">Anterior</span>
					</button>
					<button class="carousel-control-next" type="button" data-bs-target="#initiativesCarousel"
						data-bs-slide="next">
						<span class="carousel-control-next-icon" aria-hidden="true"></span>
						<span class="visually-hidden">Siguiente</span>
					</button>
				</div>
			</div>
		</div>

		<div class="row justify-content-center mt-5">
			<div class="col-lg-8">
				<hr class="my-0">
			</div>
		</div>
	</div>
</section>

<section id="collaborators" class="py-5">
	<div class="container">
		<div class="row justify-content-center mb-4">
			<div class="col-lg-8 text-center">
				<h2 class="display-5 fw-bold">En colaboración con:</h2>
				<p class="lead">En el desarrollo de este plan han colaborado instituciones educativas y organizaciones
					no gubernamentales como:</p>
			</div>
		</div>

		<div class="row justify-content-center">
			<div class="col-lg-10">
				<div id="collaboratorsCarousel" class="carousel slide" data-bs-ride="carousel">
					<!-- Indicadores -->
					<div class="carousel-indicators">
						<button type="button" data-bs-target="#collaboratorsCarousel" data-bs-slide-to="0"
							class="active" aria-label="Slide 1"></button>
						<button type="button" data-bs-target="#collaboratorsCarousel" data-bs-slide-to="1"
							aria-label="Slide 2"></button>
						<button type="button" data-bs-target="#collaboratorsCarousel" data-bs-slide-to="2"
							aria-label="Slide 3"></button>
						<button type="button" data-bs-target="#collaboratorsCarousel" data-bs-slide-to="3"
							aria-label="Slide 4"></button>
						<button type="button" data-bs-target="#collaboratorsCarousel" data-bs-slide-to="4"
							aria-label="Slide 5"></button>
						<button type="button" data-bs-target="#collaboratorsCarousel" data-bs-slide-to="5"
							aria-label="Slide 6"></button>
						<button type="button" data-bs-target="#collaboratorsCarousel" data-bs-slide-to="6"
							aria-label="Slide 7"></button>
						<button type="button" data-bs-target="#collaboratorsCarousel" data-bs-slide-to="7"
							aria-label="Slide 8"></button>
						<button type="button" data-bs-target="#collaboratorsCarousel" data-bs-slide-to="8"
							aria-label="Slide 9"></button>
						<button type="button" data-bs-target="#collaboratorsCarousel" data-bs-slide-to="9"
							aria-label="Slide 10"></button>
					</div>

					<!-- Slides -->
					<div class="carousel-inner">
						<!-- Item 1 -->
						<div class="carousel-item active">
							<div class="card border-0 bg-transparent">
								<div class="card-body">
									<img src="assets/images/Logo_UDA.jpg" class="img-fluid" alt="Universidad del Azuay">
									<blockquote class="blockquote mt-3">
										<p class="fs-5">Universidad del Azuay (Ecuador)</p>
									</blockquote>
								</div>
							</div>
						</div>

						<!-- Item 2 -->
						<div class="carousel-item">
							<div class="card border-0 bg-transparent">
								<div class="card-body">
									<img src="assets/images/Logo-UNESCO.jpg" class="img-fluid"
										alt="Unesco Regional">
									<blockquote class="blockquote mt-3">
										<p class="fs-5">Unesco Regional "Oficina Regional de Educación para América
											Latina y el Caribe" (Ecuador)</p>
									</blockquote>
								</div>
							</div>
						</div>

						<!-- Resto de los items del carrusel con la misma estructura -->

						<!-- Item 3 -->

						<div class="carousel-item">
							<div class="card border-0 bg-transparent">
								<div class="card-body">
									<img src="assets/images/gssi.png" class="img-fluid" alt="Universidad de Vigo">
									<blockquote class="blockquote mt-3">
										<p class="fs-5">Grupo de Servicios para la Sociedad de la Información -
											Universidad de Vigo (España)</p>
									</blockquote>
								</div>
							</div>
						</div>

						<!-- Item 4 -->
						<div class="carousel-item">
							<div class="card border-0 bg-transparent">
								<div class="card-body">
									<img src="assets/images/Logo_alcala.jpg" class="img-fluid"
										alt="Universidad de Alcalá">
									<blockquote class="blockquote mt-3">
										<p class="fs-5">Departamento de Ciencias de la Computación - Escuela Politécnica
											Superior - Universidad de Alcalá (España)</p>
									</blockquote>
								</div>
							</div>
						</div>

						<!-- Item 5 -->

						<div class="carousel-item">
							<div class="card border-0 bg-transparent">
								<div class="card-body">
									<img src="assets/images/Logo-UEFSTV.png" class="img-fluid"
										alt="Escuela Sor Teresa Valse">
									<blockquote class="blockquote mt-3">
										<p class="fs-5">Unidad Educativa Fiscomisional "Sor Teresa Valsé"</p>
									</blockquote>
								</div>
							</div>
						</div>

						<!-- Item 6 -->

						<div class="carousel-item">
							<div class="card border-0 bg-transparent">
								<div class="card-body">
									<img src="assets/images/CEIAP.png" class="img-fluid" alt="CEIAP">
									<blockquote class="blockquote mt-3">
										<p class="fs-5">Centro de Estimulación Integral y Apoyo Psicoterapéutico</p>
									</blockquote>
								</div>
							</div>
						</div>

						<!-- Item 7 -->

						<div class="carousel-item">
							<div class="card border-0 bg-transparent">
								<div class="card-body">
									<img src="assets/images/Logo-HOPE.png" class="img-fluid"
										alt="Hope Foundation">
									<blockquote class="blockquote mt-3">
										<p class="fs-5">Centro de Estimulación Integral y Apoyo Psicoterapéutico</p>
									</blockquote>
								</div>
							</div>
						</div>

						<!-- Item 8 -->

						<div class="carousel-item">
							<div class="card border-0 bg-transparent">
								<div class="card-body">
									<img src="assets/images/Logo-UETS.png" class="img-fluid"
										alt="Unidad Educativa Técnico Salesiano">
									<blockquote class="blockquote mt-3">
										<p class="fs-5">Unidad Educativa Técnico Salesiano</p>
									</blockquote>
								</div>
							</div>
						</div>

						<!-- Item 9 -->

						<div class="carousel-item">
							<div class="card border-0 bg-transparent">
								<div class="card-body">
									<img src="assets/images/Logo_IPCA.png" class="img-fluid" alt="IPCA">
									<blockquote class="blockquote mt-3">
										<p class="fs-5">Instituto de Parálisis Cerebral del Azuay</p>
									</blockquote>
								</div>
							</div>
						</div>

						<!-- Item 10 -->

						<div class="carousel-item">
							<div class="card border-0 bg-transparent">
								<div class="card-body">
									<img src="assets/images/Logo-Marianitas.png" class="img-fluid"
										alt="Santa Mariana de Jesús">
									<blockquote class="blockquote mt-3">
										<p class="fs-5">Unidad Educativa "Santa Mariana de Jesús"</p>
									</blockquote>
								</div>
							</div>
						</div>

					</div>

					<!-- Controles -->
					<button class="carousel-control-prev" type="button" data-bs-target="#collaboratorsCarousel"
						data-bs-slide="prev">
						<span class="carousel-control-prev-icon" aria-hidden="true"></span>
						<span class="visually-hidden">Anterior</span>
					</button>
					<button class="carousel-control-next" type="button" data-bs-target="#collaboratorsCarousel"
						data-bs-slide="next">
						<span class="carousel-control-next-icon" aria-hidden="true"></span>
						<span class="visually-hidden">Siguiente</span>
					</button>
				</div>
			</div>
		</div>
	</div>
</section>